module.exports = __webpack_public_path__ + "img/1559487896.a9df6a72.jpg";